import React from 'react'
import { Box } from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './carouselCustom.css';
import { useAppContext } from '../../App';

export default function CarouselForComponents({
  children, 
  qtyPerView, 
  customStyles = {}
}) {
  const {isMobile} = useAppContext();
  return (
    <Box style={customStyles}>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation={!isMobile}
        pagination={{clickable: true}}
        slidesPerView={qtyPerView ?? 1}
        spaceBetween={20}
        className={isMobile ? 'swiper-horizontal-mobile' : 'swiper-horizontal'}
        style={{
          paddingRight: isMobile? 0 : 25,
          paddingLeft: isMobile? 0 : 25,
        }}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide key={index} style={{ minHeight: '35vh'}}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}

